import { PolicyService } from 'src/app/services/policy.service';
import { UserService } from '../../../services/user.service';
import { Component, HostBinding, OnInit } from '@angular/core';
import { ClaimService } from 'src/app/services/claim.service';
import { LoginService } from 'src/app/services/login.service';
import { PortalBanner } from '../../models/portal-banner.interface';
@Component({
  selector: 'upsc-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit {
  @HostBinding('class') public hostClass = 'layout';
  isAdjuster: boolean;
  isThreeContractNo: boolean;
  isDynamicOutage: boolean = false;
  policies: any = {};
  countryLocale: string = 'en';
  portalBanner: PortalBanner | null = null;

  constructor(
    private userService: UserService,
    private policyService: PolicyService,
    private claimService: ClaimService,
    private loginService: LoginService,
  ) { }

  public ngOnInit() {
    this.isAdjuster = this.userService.isUserAdjuster();
    this.isThreeContractNo = this.policyService.isThreeHyphenContractNo();
    this.getBanner();
  }

  private setBannerVisibility(): void {

    if (!this.portalBanner) {
      this.isDynamicOutage = false;
      return;
    }

    const now = new Date();
    const startTime = new Date(this.portalBanner.startTime);
    const endTime = new Date(this.portalBanner.endTime);

    this.isDynamicOutage =
      now >= startTime &&
      now <= endTime;
  }

  getBanner() {

    
    const bannerDismissed = sessionStorage.getItem('portalBannerDismissed');
    if (bannerDismissed === 'true') {
      this.isDynamicOutage = false;
      return;
    }

    let flowType = sessionStorage.getItem('flowType') ?? 'ONL';
    const cachedBanner = sessionStorage.getItem('portalBanner');

    if (cachedBanner) {
      this.portalBanner = JSON.parse(cachedBanner);
      this.setBannerVisibility();
      return;
    }

    const policyNumber = flowType  === 'ONL' ? this.loginService.getPolicyDetails()?.policyNumber! : '';
    this.claimService
      .getPolicyBanners(flowType, policyNumber, '', this.countryLocale)
      .subscribe(response => {

        const banner = response?.data?.portalBanners?.[0];

        if (banner) {

          this.portalBanner = {
            messageText: banner.messageText,
            startTime: banner.startTime,
            endTime: banner.endTime
          };

          sessionStorage.setItem(
            'portalBanner',
            JSON.stringify(this.portalBanner)
          );

          this.setBannerVisibility();
        } else {
          this.isDynamicOutage = false;
        }
      });
  }

  onBannerClosed(): void {
    this.isDynamicOutage = false;
    sessionStorage.setItem('portalBannerDismissed', 'true');
  } 

}
